import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Form,
  Button,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  InputGroup,
  InputGroupAddon,
  CardHeader,
  Label,
} from "reactstrap";
import Pagination from "../../../containers/pages/Pagination";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import { useHistory } from "react-router-dom";
import { getAddressesService } from "../../../services/AccountService";
import {
  addAddressService,
  getAccountService,
  updateAddressService,
  deleteAddressService,
} from "../../../services/AccountService";
import GooglePlacesComponent from "../../components/GooglePlacesComponent";
import Geocode from "react-geocode";
import { ENV, isNullOrEmpty } from "../../../config/ENV";
import { formattedMobileNumber } from "../../../utilities/phonenumberutility";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useParams } from "react-router-dom/cjs/react-router-dom.min";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";

Geocode.setApiKey(ENV.google_api_key);

const AddressScreen = () => {
  const {id,name} = useParams()
  var accountId = id
  var accountName = name
  const [modalRight, setModalRight] = useState(false);
  const history = useHistory();
  const [search, setSearch] = useState("");
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [size, setSize] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("name");
  const [locationId, setLocationId] = useState("");
  const [locationName, setLocationName] = useState("");
  const [isSortBySelected, setIsSortBySelected] = useState(false);
  const [account, setAccount] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });
  const [addressDetails, setAddressDetails] = useState({
    name: "",
    email: "",
    // phoneNumber: "",
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const handlePhoneNumber = (e) => {
    setPhoneNumber(e);
  };
  const [address, setAddress] = useState({
    street: "",
    area: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    latitude: "",
    longitude: "",
  });
  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");
  const [modalDelete, setModalDelete] = useState(false);
  const handleCallback = (googlePlaces) => {
    setAddress((prevState) => ({
      ...prevState,
      street: googlePlaces.street,
      area: googlePlaces.area,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      country: googlePlaces.country,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
  };

  function handleItemsPerChange(e, key) {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  const sortByJobs = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };

  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getAddresses(select, col, currentPage, true);
  };

  const Back = () => {
    history.push("/accounts");
  };

  const addressDetailsHandler = (e) => {
    const { name, value } = e.target;
    setAddressDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const cancelButton = () => {
    setModalRight(false);
    clearDetails();
  };
  const openLocationDetails = () => {
    setModalRight(true);
    clearDetails();
  };

  let count = 0;

  useEffect(() => {
    let accountId = id;
    if (accountId !== "") {
      getAccountDetails(accountId);
    }
  }, [count]);

  const submitAddreess = () => {
    if (addressDetails.name === "") {
      toast.error("Please enter name");
      return;
    }

    if (isNullOrEmpty(address.latitude)) {
      toast.error("Select precise address to get better candidate matches");
      return;
    }

    if (isNullOrEmpty(address.longitude)) {
      toast.error("Select precise address to get better candidate matches");
      return;
    }

    if (selectedLocationId === "") {
      createAccountAddress();
    } else {
      updateAddress();
    }
  };

  function handleSearch(e, key) {
    setSearch(e.target.value);
  }

  useEffect(() => {
    getAddresses(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  const getAddresses = (sortOrder, sortBy, currentpage, isSortBySelected) => {
    setCurrentPage(currentpage);

    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (sessionStorage.getItem("locationSortBy") !== null) {
      const sortByValue = sessionStorage.getItem("locationSortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("locationSortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("locationSortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("locationSortBy", sortBy);
    }
    if (sessionStorage.getItem("locationSortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("locationSortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("locationSortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("locationSortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("locationSortOrder", sortOrder);
    }

    getAddressesService(
      accountId,
      search,
      itemsPerPage,
      currentpage,
      sortBy,
      sortOrder
    ).then((response) => {
      try {
        if (response.data != null) {

          console.log("getaddressserviceclass"+JSON.stringify(response.data))
          let size = response.data.size;
          if (size > 0) {
            setSize(size);
          } else {
            setSize(size);
          }
          var addressDetails = response.data.accountAddress;
          if (addressDetails != null) {
            setLocations(addressDetails);

            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const createAccountAddress = () => {
    if (address.latitude !== "" && address.latitude !== 0) {
      addAddress(address.latitude, address.longitude);
    } else {
      const fullAddress =
        address.street +
        "," +
        address.area +
        "," +
        address.city +
        "," +
        address.state +
        "," +
        address.zipcode +
        "," +
        address.country;
      Geocode.fromAddress(fullAddress).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          if (lat !== null && lng !== null) {
            addAddress(lat, lng);
          } else {
            toast.error("Unable to fetch address, Please try again");
          }
        },
        (error) => {
          console.error(error);
          toast.error("Unable to fetch address, Please try again");
        }
      );
    }
  };

  const addAddress = (latitude, longitude) => {
    const addressRequest = {
      street: address.street,
      area: address.area,
      city: address.city,
      state: address.state,
      zipcode: address.zipcode,
      country: address.country,
      latitude: latitude,
      longitude: longitude,
    };

    const createAddressRequest = {
      name: addressDetails.name,
      email: addressDetails.email,
      phoneNumber: phoneNumber,
      address: addressRequest,
    };

    addAddressService(createAddressRequest,accountId).then((response) => {
      try {
        setModalRight(false);
        getAddresses(sortOrder, sortBy, 1);
        clearDetails();
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const handleDeleteLocation = (deletedId, name) => {
    setLocationId(deletedId);
    setLocationName(name);
    setModalDelete(deletedId);
  };

  const deleteaddress = () => {
    deleteAddressService(locationId).then((response) => {
      try {
        if (response.message != null) {
          // toast.error("Account in use");
        } else {
          toast.success("Location deleted successfully");
          getAddresses(sortOrder, sortBy, 1);
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
      setModalDelete(false);
    });
  };

  const updateAddress = (accountId) => {
    if (address.latitude !== "" && address.latitude !== 0) {
      updateAccAddress(address.latitude, address.longitude, accountId);
    } else {
      const fullAddress =
        address.street +
        "," +
        address.area +
        "," +
        address.city +
        "," +
        address.state +
        "," +
        address.zipcode +
        "," +
        address.country;
      Geocode.fromAddress(fullAddress).then(
        (response) => {
          const { lat, lng } = response.results[0].geometry.location;
          if (lat !== null && lng !== null) {
            updateAccAddress(lat, lng, accountId);
          } else {
            toast.error("Unable to fetch address, Please try again");
          }
        },
        (error) => {
          console.error(error);
          toast.error("Unable to fetch address, Please try again");
        }
      );
    }
  };

  const updateAccAddress = (latitude, longitude, accountId) => {
    const addressRequest = {
      street: address.street,
      area: address.area,
      city: address.city,
      state: address.state,
      zipcode: address.zipcode,
      country: address.country,
      latitude: latitude,
      longitude: longitude,
    };

    const createAddressRequest = {
      name: addressDetails.name,
      email: addressDetails.email,
      phoneNumber: phoneNumber,
      address: addressRequest,
    };

    updateAddressService(
      createAddressRequest,
      accountId,
      selectedLocationId
    ).then((response) => {
      try {
        if (response.data !== null) {
          toast.success(" Account Location updated successfully");
          setModalRight(false);
          getAddresses(sortOrder, sortBy, 1);
          clearDetails();
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const getAccountDetails = (accountId) => {
    getAccountService(accountId).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          var AccountDetails = response.data;
          if (AccountDetails != null) {
            if (AccountDetails.name !== null || AccountDetails.name !== "") {
              setAccount((prevState) => ({
                ...prevState,
                name: AccountDetails.name,
              }));
            }
            if (AccountDetails.email !== null || AccountDetails.email !== "") {
              setAccount((prevState) => ({
                ...prevState,
                email: AccountDetails.email,
              }));
            }
            if (
              AccountDetails.phoneNumber !== null ||
              AccountDetails.phoneNumber !== ""
            ) {
              setAccount((prevState) => ({
                ...prevState,
                phoneNumber: AccountDetails.phoneNumber,
              }));
            }
          }
        }
      } catch (err) {
        console.log("message" + JSON.stringify(err.message));
      }
    });
  };

  const updateLocationModel = (location) => {
    setModalRight(true);
    setSelectedLocationId(location.id);
    if (location.name !== null || location.name !== "") {
      setAddressDetails((prevState) => ({
        ...prevState,
        name: location.name,
      }));
    }

    if (location.email !== null || location.email !== "") {
      setAddressDetails((prevState) => ({
        ...prevState,
        email: location.email,
      }));
    }

    if (location.phoneNumber !== null || location.phoneNumber !== "") {
      // setAddressDetails((prevState) => ({
      //   ...prevState,
      //   phoneNumber: location.phoneNumber,
      // }));
      setPhoneNumber(location.phoneNumber);
    }

    if (location.address.street !== null || location.address.street !== "") {
      setAddress((prevState) => ({
        ...prevState,
        street: location.address.street,
      }));
    }

    if (location.address.area !== null || location.address.area !== "") {
      setAddress((prevState) => ({
        ...prevState,
        area: location.address.area,
      }));
    }

    if (location.address.city !== null || location.address.city !== "") {
      setAddress((prevState) => ({
        ...prevState,
        city: location.address.city,
      }));
    }

    if (location.address.state !== null || location.address.state !== "") {
      setAddress((prevState) => ({
        ...prevState,
        state: location.address.state,
      }));
    }

    if (location.address.zipcode !== null || location.address.zipcode !== "") {
      setAddress((prevState) => ({
        ...prevState,
        zipcode: location.address.zipcode,
      }));
    }

    if (location.address.country !== null || location.address.country !== "") {
      setAddress((prevState) => ({
        ...prevState,
        country: location.address.country,
      }));
    }
    if (
      location.address.latitude !== null ||
      location.address.latitude !== ""
    ) {
      setAddress((prevState) => ({
        ...prevState,
        latitude: location.address.latitude,
      }));
    }

    if (
      location.address.longitude !== null ||
      location.address.longitude !== ""
    ) {
      setAddress((prevState) => ({
        ...prevState,
        longitude: location.address.longitude,
      }));
    }
  };

  const clearDetails = () => {
    setSelectedLocationId("");

    setAddressDetails((prevState) => ({
      ...prevState,
      name: "",
      email: "",
      // phoneNumber: "",
    }));
    setPhoneNumber("");
    setAddress((prevState) => ({
      ...prevState,
      street: "",
      area: "",
      city: "",
      state: "",
      zipcode: "",
      country: "",
      latitude: "",
      longitude: "",
    }));
  };

  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };
  const showStreetArea = (location) => {
    if (!isNullOrEmpty(location)) {
      var arr = [];
      if (!isNullOrEmpty(location.city)) {
        arr.push(location.city);
      }
      if (!isNullOrEmpty(location.state)) {
        arr.push(location.state);
      }
    }
    return arr.join(", ");
  };

  const displaySearchAddress = (address) => {
    return (
      <>
        <FormGroup>
          <Row>{address.street !== "" && <>{address.street}</>}</Row>
          <Row>
            {showStreetArea(address)}{" "}
            {address.zipcode !== "" && <>{address.zipcode}</>}
          </Row>
          <Row>{address.country !== "" && <>{address.country}</>}</Row>
        </FormGroup>
      </>
    );
  };
  const displayTableHeaders = () => {
    return (
      <>
        <th className="w-5">S.No</th>
        <th onClick={() => sortByJobs("name")} className="w-15">
          <Row className="w-[240]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Location Name </div>
            <div className="col">
              {sortBy == "name" ? (
                <>
                  {" "}
                  {sortBy === "name" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th
          className="w-10"
        >
          Contact Name
        </th>

        <th
          className="w-10"
        >
          Email
        </th>
        <th className="w-10">Mobile Number</th>

        <th onClick={() => sortByJobs("address.city")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> City </div>
            <div className="col">
              {sortBy === "address.city" ? (
                <>
                  {" "}
                  {sortBy === "address.city" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th onClick={() => sortByJobs("address.state")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> State </div>
            <div className="col">
              {sortBy == "address.state" ? (
                <>
                  {sortBy === "address.state" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>

        <th onClick={() => sortByJobs("address.zipcode")} className="w-10">
          <Row className="w-[100]">
            {" "}
            <div className="col pr-1 t-cursor-pointer"> Zipcode </div>
            <div className="col">
              {sortBy === "address.zipcode" ? (
                <>
                  {sortBy === "address.zipcode" ? (
                    sortOrder === "asc" ? (
                      <>
                        <Row>
                          <SvgSelectedUpArrow />
                        </Row>
                        <Row>
                          <SvgDownArrow />
                        </Row>
                      </>
                    ) : (
                      <>
                        <Row>
                          <SvgUpArrow />
                        </Row>
                        <Row>
                          {" "}
                          <SvgSelectedDownArrow />
                        </Row>
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {" "}
                  <Row>
                    <SvgUpArrow />
                  </Row>
                  <Row>
                    <SvgDownArrow />
                  </Row>
                </>
              )}
            </div>
          </Row>
        </th>
        <th className="w-10">Actions</th>
      </>
    );
  };

  return (
    <>
      <Row>
        <Colxx xxs="12">
          <Card className="mt-2">
            {
              <Row>
                <Colxx xxs="12">
                  <div>
                    <CardHeader>
                      <div className="row">
                        <Colxx sm={10} style={{ padding: 0 }}>
                          <div className="col">
                            <div className=" ml-3">
                              <h3 className="mt-2">
                                <b>{accountName}</b> | Work Locations
                              </h3>
                            </div>
                          </div>
                        </Colxx>
                        <Colxx sm={2}>
                          <div className="btn-group float-right">
                            <Button
                              outline
                              size="sm"
                              color="primary"
                              onClick={Back}
                            >
                              Back
                            </Button>

                            <Button
                              color="primary"
                              className=""
                              size="sm"
                              outline
                              onClick={openLocationDetails}
                            >
                              Add
                            </Button>
                          </div>
                        </Colxx>
                      </div>
                    </CardHeader>
                    <CardBody>
                      <Colxx className="mb-4">
                        <Row className="mt-2">
                          <Colxx sm={4} style={{ padding: 0 }}>
                            <InputGroup>
                              <Input
                                type=""
                                name=""
                                placeholder="Search"
                                onChange={handleSearch}
                                value={search}
                                className="form-control"
                              ></Input>
                              <InputGroupAddon addonType="append">
                                <Button
                                  outline
                                  color="primary"
                                  onClick={(e) =>
                                    getAddresses(sortOrder, sortBy, 1)
                                  }
                                >
                                  Search
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                          </Colxx>
                          <Colxx sm={4}></Colxx>
                          <Colxx sm={4} className="address_page">
                            <Input
                              type="select"
                              value={itemsPerPage}
                              onChange={handleItemsPerChange}
                            >
                              <option value={""}>Items Per Page</option>
                              <option value={"10"}>10</option>
                              <option value={"25"}>25</option>
                              <option value={"50"}>50</option>
                              <option value={"100"}>100</option>
                            </Input>
                          </Colxx>
                        </Row>
                      </Colxx>
                      <Modal
                        isOpen={Boolean(modalRight)}
                        toggle={() => setModalRight(!modalRight)}
                        wrapClassName="modal-right"
                      >
                        <Row>
                          <Colxx xxs="12">
                            <Card>
                              <CardBody>
                                <CardTitle>
                                  {selectedLocationId === "" ? (
                                    <strong>Add a new work location</strong>
                                  ) : (
                                    <strong>
                                      Update existing work location
                                    </strong>
                                  )}
                                </CardTitle>
                                <Form>
                                  <FormGroup row>
                                    <Colxx sm={12}>
                                    <FormGroup>
                                      <Label>
                                        Name*
                                      </Label>
                                      <Input
                                        className="t-rounded-lg"
                                        type="name"
                                        name="name"
                                        data-testid="location-name"
                                        onChange={addressDetailsHandler}
                                        value={addressDetails.name}
                                      />
                                    </FormGroup>
                                    </Colxx>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Colxx sm={12}>
                                      <GooglePlacesComponent
                                        parentCallback={handleCallback}
                                      />
                                    </Colxx>
                                  </FormGroup>
                                  <FormGroup>
                                    <Colxx sm={12}>
                                      {displaySearchAddress(address)}
                                    </Colxx>
                                  </FormGroup>
                                </Form>
                              </CardBody>
                            </Card>
                          </Colxx>
                        </Row>

                        <ModalFooter className="model-button modal-bottom-location">
                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className="mt-4"
                            onClick={submitAddreess}
                          >
                            Save
                          </Button>

                          <Button
                            color="primary"
                            size="sm"
                            outline
                            className=" mt-4 ml-1"
                            onClick={cancelButton}
                          >
                            Cancel
                          </Button>
                        </ModalFooter>
                      </Modal>
                      <Colxx sm={12} className="mt-2 location-table">
                        <div>
                          <div className="tableContainer">
                            <div className="tablewrapper">
                              <Table className=" hms_table jobRequisition_table table-responsive ">
                                <thead>
                                  <tr>{displayTableHeaders()}</tr>
                                </thead>
                                {locations.length > 0 ? (
                                  locations.map((location, index) => {
                                    return (
                                      <tbody key={index}>
                                        <tr>
                                          <td className="w-[60]">
                                            {getSerialNumber(index)}
                                          </td>
                                          <td className="w-[120]">
                                            <u>
                                              <Link
                                                className="text-dark"
                                                onClick={() => {
                                                  updateLocationModel(location);
                                                }}
                                                title="Edit Location"
                                              >
                                                {location.name}
                                              </Link>
                                            </u>
                                          </td>

                                          <td className="w-[120]">
                                            {!isNullOrEmpty(
                                              location.primaryContacts
                                            ) ? (
                                              <>
                                                {
                                                  location.primaryContacts[0]
                                                    .firstName
                                                }{" "}
                                                {
                                                  location.primaryContacts[0]
                                                    .lastName
                                                }
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>
                                          <td className="w-[180]">
                                            {!isNullOrEmpty(
                                              location.primaryContacts
                                            ) ? (
                                              <>
                                                {
                                                  location.primaryContacts[0]
                                                    .email
                                                }
                                              </>
                                            ) : (
                                              <></>
                                            )}
                                          </td>

                                          <td className="w-[120]">
                                            <>
                                              {!isNullOrEmpty(
                                                location.primaryContacts
                                              ) ? (
                                                <>
                                                  {formattedMobileNumber(
                                                    location.primaryContacts[0]
                                                      .mobileNumber
                                                  )}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          </td>
                                          {/* <td className="w-[120]">
                                              {showStreetArea(location)}
                                            </td> */}
                                          <td className="w-[120]">
                                            {location.address.city}
                                          </td>
                                          <td className="w-[120]">
                                            {location.address.state}
                                          </td>
                                          {/* <td className="w-[120]">
                                              {location.address.country}
                                            </td> */}
                                          <td className="w-[120]">
                                            {location.address.zipcode}
                                          </td>
                                          <td className="w-[120]">
                                            <>
                                              <div>
                                                <Link
                                                  className="benifit-symbol-color"
                                                  // to="/location"
                                                  to={{pathname : `/location/${location.id}/${location.name}/${accountId}/${accountName}`}}
                                                  title="Location Contacts"
                                                  size={5}
                                                  // onClick={() => {
                                                  //   window.localStorage.setItem(
                                                  //     "locationId",
                                                  //     location.id
                                                  //   );
                                                  //   window.localStorage.setItem(
                                                  //     "locationName",
                                                  //     location.name
                                                  //   );
                                                  //   window.localStorage.setItem(
                                                  //     "locationId",
                                                  //     location.id
                                                  //   );
                                                  //   window.localStorage.setItem(
                                                  //     "accountName",
                                                  //     account.name
                                                  //   );
                                                  // }}
                                                >
                                                  <i
                                                    className=" w-5 simple-icon-user-follow mr-1 arrow-icon-color"
                                                    color="red"
                                                  />{" "}
                                                </Link>
                                                <>
                                                  <i
                                                    title="Delete Location"
                                                    className="simple-icon-trash ic-profile text-dark delete-icon ml-2 emp_icon t-cursor-pointer"
                                                    onClick={() =>
                                                      handleDeleteLocation(
                                                        location.id,
                                                        location.name
                                                      )
                                                    }
                                                  />
                                                </>
                                              </div>
                                            </>
                                          </td>
                                        </tr>
                                      </tbody>
                                    );
                                  })
                                ) : (
                                  <tfoot></tfoot>
                                )}
                              </Table>
                            </div>
                          </div>
                          {locations == "" || locations == null ? (
                            <>
                              {" "}
                              <p className="nodata-text">
                                No account locations available
                              </p>
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      </Colxx>
                      <hr></hr>
                      <Pagination
                        currentPage={currentPage}
                        totalPage={totalPage}
                        numberLimit={5}
                        firstIsActive={true}
                        onChangePage={(e) => onChangePage(e)}
                      />{" "}
                      <h3> Total matching records : {size} </h3>
                    </CardBody>
                  </div>
                </Colxx>

                <Separator className="mt-5 mb-5"></Separator>
              </Row>
            }
          </Card>
        </Colxx>
      </Row>

      <Modal
        isOpen={Boolean(modalDelete)}
        toggle={() => setModalDelete(!modalDelete)}
      >
        <ModalBody>
          Do you want to delete location <strong> {"  " + locationName}</strong>
          ?
        </ModalBody>
        <ModalFooter className="p-3">
          {" "}
          <Button
            color="primary"
            size="sm"
            outline
            onClick={() => setModalDelete(false)}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            size="sm"
            outline
            onClick={(e) => {
              deleteaddress();
            }}
          >
            Delete
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default AddressScreen;
